export default "__VITE_ASSET__sZbehMe4__"